import { BaseAPI } from '../base.api';
import VeiculoTransportadora from '@/models/veiculoTransportadora';
import { VUE_APP_SIT_PEDIDOS_API_URL } from "@/commons/config"
import { AxiosObservable } from 'axios-observable/dist/axios-observable.interface';
import { map } from 'rxjs/operators';

export interface PaginateVeiculoTransportadora{
  page: number
  size:number
}

export class VeiculoTransportadoraAPI extends BaseAPI<VeiculoTransportadora> {
  constructor() {
    super()
    this.apiUrl = `${VUE_APP_SIT_PEDIDOS_API_URL}/api`
  }

  public list({page, size}: PaginateVeiculoTransportadora): AxiosObservable<any> {
    return this.axios.get(`${this.apiUrl}/veiculos-transportadoras/?size=${size}&page=${page}`)
  }

  // TODO: remover esse método quando backend implementar um search de Veículo Transportadora
  public listExcludes({page, size}: PaginateVeiculoTransportadora): AxiosObservable<any> {
    return this.axios.get(`${this.apiUrl}/veiculos-transportadoras/exclusao/?size=${size}&page=${page}`)
  }
}
